import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const StyledHeader = styled.nav`
  background: lightgray;
  width: 100%;
  color: var(--white);
  display: flex;
  justify-content: center;
  background: rgb(6 81 180);
`;
const Link = styled(NavLink)`
  display: inline-block;
  font-weight: bold;
  padding: 0.7em 2em;
  background: #888888ad;
  border: 0;
  color: var(--white);
  margin: 0 1em;
  cursor: pointer;
  transition: background-color 200ms;
  text-decoration: none;
  &.active {
    background: var(--white);
    color: var(--black);
  }
  &:hover,
  &:focus {
    text-decoration: underline;
  }
  @media (max-width: 576px) {
    padding: 0.7em 1em;
    display: flex;
    align-items: center;
    text-align: center;
    margin: 0 0.5em;
    font-size: 0.9rem;
  }
`;

const Header = () => {
  return (
    <StyledHeader>
      <Link to="/" exact>
        Čakáreň dáta
      </Link>
      <Link to="kalkulacka" exact>
        Kalkulačka
      </Link>
      <Link to="projekt" exact>
        O projekte
      </Link>
    </StyledHeader>
  );
};

export default Header;
